var _linearGradient, _path, _linearGradient2, _path2, _linearGradient3, _path3, _linearGradient4, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGoogleLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 26,
    height: 26
  }, props), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-logo_svg__a",
    x1: 29.401,
    x2: 29.401,
    y1: 4.064,
    y2: 106.734,
    gradientTransform: "matrix(1 0 0 -1 0 66)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff5840"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#ff5840"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989,
    stopColor: "#fa528c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fa528c"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#google-logo_svg__a)",
    d: "M47.46 15.5l-1.37 1.48c-1.34 1.44-3.5 1.67-5.15.6-2.71-1.75-6.43-3.13-11-2.37-4.94.83-9.17 3.85-11.64 7.97l-8.03-6.08C14.99 9.82 23.2 5 32.5 5c5 0 9.94 1.56 14.27 4.46 2.04 1.37 2.36 4.25.69 6.04z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-logo_svg__b",
    x1: 12.148,
    x2: 12.148,
    y1: 0.872,
    y2: 47.812,
    gradientTransform: "matrix(1 0 0 -1 0 66)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#feaa53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.612,
    stopColor: "#ffcd49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffde44"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#google-logo_svg__b)",
    d: "M16.01 30.91c-.09 2.47.37 4.83 1.27 6.96l-8.21 6.05c-1.35-2.51-2.3-5.28-2.75-8.22-1.06-6.88.54-13.38 3.95-18.6l8.03 6.08c-1.37 2.29-2.2 4.93-2.29 7.73z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-logo_svg__c",
    x1: 29.76,
    x2: 29.76,
    y1: 32.149,
    y2: -6.939,
    gradientTransform: "matrix(1 0 0 -1 0 66)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#42d778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.428,
    stopColor: "#3dca76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34b171"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#google-logo_svg__c)",
    d: "M50.45 51.28c-4.55 4.07-10.61 6.57-17.36 6.71-10.18.21-19.43-5.46-24.02-14.07l8.21-6.05C19.78 43.81 25.67 48 32.5 48c3.94 0 7.52-1.28 10.33-3.44l7.62 6.72z"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-logo_svg__d",
    x1: 46,
    x2: 46,
    y1: 3.638,
    y2: 35.593,
    gradientTransform: "matrix(1 0 0 -1 0 66)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#155cde"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.278,
    stopColor: "#1f7fe5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.569,
    stopColor: "#279ceb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#2cafef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2eb5f0"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#google-logo_svg__d)",
    d: "M59 31.97c.01 7.73-3.26 14.58-8.55 19.31l-7.62-6.72c2.1-1.61 3.77-3.71 4.84-6.15.29-.66-.2-1.41-.92-1.41H37c-2.21 0-4-1.79-4-4v-2c0-2.21 1.79-4 4-4h17c2.75 0 5 2.22 5 4.97z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2NCA2NCIgd2lkdGg9IjI2cHgiIGhlaWdodD0iMjZweCI+PGxpbmVhckdyYWRpZW50IGlkPSI5NXlZN3c0M09qNm4ydkg2M2o2SEpiIiB4MT0iMjkuNDAxIiB4Mj0iMjkuNDAxIiB5MT0iNC4wNjQiIHkyPSIxMDYuNzM0IiBncmFkaWVudFRyYW5zZm9ybT0ibWF0cml4KDEgMCAwIC0xIDAgNjYpIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHN0b3Agb2Zmc2V0PSIwIiBzdG9wLWNvbG9yPSIjZmY1ODQwIj48L3N0b3A+PHN0b3Agb2Zmc2V0PSIuMDA3IiBzdG9wLWNvbG9yPSIjZmY1ODQwIj48L3N0b3A+PHN0b3Agb2Zmc2V0PSIuOTg5IiBzdG9wLWNvbG9yPSIjZmE1MjhjIj48L3N0b3A+PHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjZmE1MjhjIj48L3N0b3A+PC9saW5lYXJHcmFkaWVudD48cGF0aCBmaWxsPSJ1cmwoIzk1eVk3dzQzT2o2bjJ2SDYzajZISmIpIiBkPSJNNDcuNDYsMTUuNWwtMS4zNywxLjQ4Yy0xLjM0LDEuNDQtMy41LDEuNjctNS4xNSwwLjZjLTIuNzEtMS43NS02LjQzLTMuMTMtMTEtMi4zNwljLTQuOTQsMC44My05LjE3LDMuODUtMTEuNjQsIDcuOTdsLTguMDMtNi4wOEMxNC45OSw5LjgyLDIzLjIsNSwzMi41LDVjNSwwLDkuOTQsMS41NiwxNC4yNyw0LjQ2CUM0OC44MSwxMC44Myw0OS4xMywxMy43MSw0Ny40NiwxNS41eiI+PC9wYXRoPjxsaW5lYXJHcmFkaWVudCBpZD0iOTV5WTd3NDNPajZuMnZINjNqNkhKYyIgeDE9IjEyLjE0OCIgeDI9IjEyLjE0OCIgeTE9Ii44NzIiIHkyPSI0Ny44MTIiIGdyYWRpZW50VHJhbnNmb3JtPSJtYXRyaXgoMSAwIDAgLTEgMCA2NikiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj48c3RvcCBvZmZzZXQ9IjAiIHN0b3AtY29sb3I9IiNmZWFhNTMiPjwvc3RvcD48c3RvcCBvZmZzZXQ9Ii42MTIiIHN0b3AtY29sb3I9IiNmZmNkNDkiPjwvc3RvcD48c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiNmZmRlNDQiPjwvc3RvcD48L2xpbmVhckdyYWRpZW50PjxwYXRoIGZpbGw9InVybCgjOTV5WTd3NDNPajZuMnZINjNqNkhKYykiIGQ9Ik0xNi4wMSwzMC45MWMtMC4wOSwyLjQ3LDAuMzcsNC44MywxLjI3LDYuOTZsLTguMjEsNi4wNWMtMS4zNS0yLjUxLTIuMy01LjI4LTIuNzUtOC4yMgljLTEuMDYtNi44OCwwLjU0LTEzLjM4LCAzLjk1LTE4LjZsOC4wMyw2LjA4QzE2LjkzLDI1LjQ3LDE2LjEsMjguMTEsMTYuMDEsMzAuOTF6Ij48L3BhdGg+PGxpbmVhckdyYWRpZW50IGlkPSI5NXlZN3c0M09qNm4ydkg2M2o2SEpkIiB4MT0iMjkuNzYiIHgyPSIyOS43NiIgeTE9IjMyLjE0OSIgeTI9Ii02LjkzOSIgZ3JhZGllbnRUcmFuc2Zvcm09Im1hdHJpeCgxIDAgMCAtMSAwIDY2KSIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPjxzdG9wIG9mZnNldD0iMCIgc3RvcC1jb2xvcj0iIzQyZDc3OCI+PC9zdG9wPjxzdG9wIG9mZnNldD0iLjQyOCIgc3RvcC1jb2xvcj0iIzNkY2E3NiI+PC9zdG9wPjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iIzM0YjE3MSI+PC9zdG9wPjwvbGluZWFyR3JhZGllbnQ+PHBhdGggZmlsbD0idXJsKCM5NXlZN3c0M09qNm4ydkg2M2o2SEpkKSIgZD0iTTUwLjQ1LDUxLjI4Yy00LjU1LDQuMDctMTAuNjEsNi41Ny0xNy4zNiw2LjcxQzIyLjkxLDU4LjIsMTMuNjYsNTIuNTMsOS4wNyw0My45Mmw4LjIxLTYuMDUJQzE5Ljc4LDQzLjgxLCAyNS42Nyw0OCwzMi41LDQ4YzMuOTQsMCw3LjUyLTEuMjgsMTAuMzMtMy40NEw1MC40NSw1MS4yOHoiPjwvcGF0aD48bGluZWFyR3JhZGllbnQgaWQ9Ijk1eVk3dzQzT2o2bjJ2SDYzajZISmUiIHgxPSI0NiIgeDI9IjQ2IiB5MT0iMy42MzgiIHkyPSIzNS41OTMiIGdyYWRpZW50VHJhbnNmb3JtPSJtYXRyaXgoMSAwIDAgLTEgMCA2NikiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj48c3RvcCBvZmZzZXQ9IjAiIHN0b3AtY29sb3I9IiMxNTVjZGUiPjwvc3RvcD48c3RvcCBvZmZzZXQ9Ii4yNzgiIHN0b3AtY29sb3I9IiMxZjdmZTUiPjwvc3RvcD48c3RvcCBvZmZzZXQ9Ii41NjkiIHN0b3AtY29sb3I9IiMyNzljZWIiPjwvc3RvcD48c3RvcCBvZmZzZXQ9Ii44MiIgc3RvcC1jb2xvcj0iIzJjYWZlZiI+PC9zdG9wPjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iIzJlYjVmMCI+PC9zdG9wPjwvbGluZWFyR3JhZGllbnQ+PHBhdGggZmlsbD0idXJsKCM5NXlZN3c0M09qNm4ydkg2M2o2SEplKSIgZD0iTTU5LDMxLjk3YzAuMDEsNy43My0zLjI2LDE0LjU4LTguNTUsMTkuMzFsLTcuNjItNi43MmMyLjEtMS42MSwzLjc3LTMuNzEsNC44NC02LjE1IGMwLjI5LTAuNjYtMC4yLTEuNDEtMC45Mi0xLjQxSDM3Yy0yLjIxLDAtNC0xLjc5LTQtNHYtMmMwLTIuMjEsMS43OS00LDQtNGgxN0M1Ni43NSwyNyw1OSwyOS4yMiw1OSwzMS45N3oiPjwvcGF0aD48L3N2Zz4K";
export { SvgGoogleLogo as ReactComponent };